export default {"src":"/_next/static/media/BMRN.02dbdd76.svg","height":18,"width":18};